import React from "react";

/*
 * Persistent WhatsApp FAB — sticky bottom-right on every route.
 * Single bubble, no pre-fill message. Opens wa.me in a new tab.
 */
const WHATSAPP_NUMBER = "918796383008"; // India · +91 87963 83008

const WhatsappIcon = ({ size = 30 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    aria-hidden="true"
  >
    <path
      fill="#ffffff"
      d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.638 3.41 4.53 4.582.688.416 1.418.744 2.17 1.006.628.215 1.29.487 1.977.487.34 0 .68-.028 1.023-.086.803-.156 1.876-.797 2.24-1.55.114-.228.114-.428.043-.685-.157-.43-1.667-.83-1.883-.83z"
    />
    <path
      fill="#ffffff"
      d="M16 4.667C9.746 4.667 4.667 9.746 4.667 16c0 2 .53 3.94 1.54 5.638L4.79 26.285a.667.667 0 0 0 .823.822l4.664-1.4A11.276 11.276 0 0 0 16 27.333c6.254 0 11.333-5.079 11.333-11.333S22.254 4.667 16 4.667zm0 20.667a9.28 9.28 0 0 1-4.783-1.322.667.667 0 0 0-.53-.061l-3.555 1.068 1.084-3.54a.667.667 0 0 0-.061-.523A9.28 9.28 0 0 1 6.667 16C6.667 10.85 10.85 6.667 16 6.667S25.333 10.85 25.333 16 21.15 25.333 16 25.333z"
    />
  </svg>
);

export const WhatsappFab = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with BBC on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-[60] group"
    >
      <span
        aria-hidden
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping"
        style={{ animationDuration: "2.4s" }}
      />
      <span
        className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.45)] ring-1 ring-white/10 transition-transform duration-200 group-hover:scale-105 group-active:scale-95"
      >
        <WhatsappIcon size={30} />
      </span>
    </a>
  );
};

export default WhatsappFab;
